import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Hero() {
  const { t, i18n } = useTranslation();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  const scrollToPackages = () => {
    const packagesSection = document.getElementById('packages-section');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/8a84e78b3142c84f3c27c9b4063b58ca.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      />
      
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 via-blue-800/70 to-green-700/80"></div>
      
      <button
        onClick={toggleLanguage}
        className="absolute top-6 right-6 bg-white/10 backdrop-blur-lg border border-white/20 text-white px-6 py-3 rounded-full hover:bg-white/20 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer z-10 shadow-lg hover:shadow-xl hover:scale-105"
      >
        <i className="ri-global-line text-xl"></i>
        <span className="font-medium">{i18n.language === 'ar' ? 'English' : 'العربية'}</span>
      </button>

      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto">
        <div className="mb-8 inline-block animate-float">
          <div className="w-28 h-28 bg-gradient-to-br from-blue-400 to-green-400 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-2xl relative">
            <div className="absolute inset-0 bg-white/20 rounded-3xl animate-pulse"></div>
            <i className="ri-wifi-line text-6xl text-white relative z-10"></i>
          </div>
        </div>
        
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-tight animate-fade-in">
          {t('heroTitle')}
        </h1>
        
        <p className="text-xl md:text-3xl text-white/95 mb-12 leading-relaxed max-w-4xl mx-auto font-light animate-fade-in-delay">
          {t('heroSubtitle')}
        </p>

        <button
          onClick={scrollToPackages}
          className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-12 py-5 rounded-full text-xl font-bold shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 cursor-pointer whitespace-nowrap mb-16 inline-flex items-center gap-3"
        >
          <span>{t('getStarted', 'ابدأ الآن')}</span>
          <i className="ri-arrow-right-line text-2xl"></i>
        </button>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 px-8 py-6 rounded-2xl flex items-center gap-4 hover:bg-white/20 transition-all duration-300 hover:scale-105 cursor-pointer shadow-lg">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <span className="text-white font-semibold text-lg">{t('securePayment')}</span>
          </div>
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 px-8 py-6 rounded-2xl flex items-center gap-4 hover:bg-white/20 transition-all duration-300 hover:scale-105 cursor-pointer shadow-lg">
            <div className="w-14 h-14 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-flashlight-line text-3xl text-white"></i>
            </div>
            <span className="text-white font-semibold text-lg">{t('instantActivation')}</span>
          </div>
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 px-8 py-6 rounded-2xl flex items-center gap-4 hover:bg-white/20 transition-all duration-300 hover:scale-105 cursor-pointer shadow-lg">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-400 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-customer-service-2-line text-3xl text-white"></i>
            </div>
            <span className="text-white font-semibold text-lg">{t('support247')}</span>
          </div>
        </div>

        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-5xl text-white/80"></i>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        .animate-fade-in-delay {
          animation: fade-in 1s ease-out 0.3s both;
        }
      `}</style>
    </div>
  );
}
